export default [
    {
        name: "wheel",
        path: "/wheel",
        component: () => import("@/modules/Wheel"),
    },
];
